<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" sm="12">
        <AppSectionHero :section-number="0">
          <template v-slot:title>{{
            $t("content.sections.intro.subtitle")
          }}</template>
        </AppSectionHero>
        <p>
          {{ $t(`content.sections.intro.intro-1`) }}
        </p>
        <p>
          {{ $t(`content.sections.intro.intro-2`) }}
        </p>
        <AppMoreInfoCard :section-number="0" class="pt-5">
          <template v-slot:card-info>
            <i18n
              tag="div"
              path="content.sections.intro.legalProblemsAlert.intro"
            >
              <span
                class="section0--text font-weight-black"
                slot="legalProblems"
                >{{
                  $t("content.sections.intro.legalProblemsAlert.legalProblems")
                }}</span
              >
            </i18n>
          </template>
          <template v-slot:more-info-title>{{
            $t("content.sections.intro.legalProblemsAlert.moreInfoTitle")
          }}</template>
          <template v-slot:more-info-text
            ><p>
              {{
                $t("content.sections.intro.legalProblemsAlert.moreInfoText-1")
              }}
            </p>
            <div>
              {{
                $t("content.sections.intro.legalProblemsAlert.moreInfoText-2")
              }}
            </div></template
          >
        </AppMoreInfoCard>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <TheFactsGrid />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppSectionHero from "@/components/AppSectionHero.vue";
import TheFactsGrid from "@/components/TheFactsGrid.vue";
import AppMoreInfoCard from "@/components/AppMoreInfoCard.vue";
export default {
  components: {
    AppSectionHero,
    TheFactsGrid,
    AppMoreInfoCard
  }
};
</script>